export function addNotif(data) {
  return {
    type: "ADD_NOTIF",
    payload: data,
  };
}

export function addOffer(data) {
  return {
    type: "ADD_OFFER",
    payload: data,
  };
}
export function markNotifAsRead(data) {
  return {
    type: "MARK_READ",
    payload: data,
  };
}
